require('./brokerAdvancedSearchResultRiskIndicator.scss')
// @vendors
const React = require('react');
const PropTypes = require('prop-types');
const { formatText } = require('core/i18n').i18n;

//constats
const { SLASH } = require('constants/index');

class BrokerAdvancedSearchResultRiskIndicator extends React.Component {

    indicatorClassName(indicator, index){
        const ClassName = indicator
        ? `broker-advanced-search-result-risk-indicator__indicator-bar broker-advanced-search-result-risk-indicator__indicator-bar-${index} broker-advanced-search-result-risk-indicator__indicator--on`
        : `broker-advanced-search-result-risk-indicator__indicator-bar broker-advanced-search-result-risk-indicator__indicator-bar-${index} broker-advanced-search-result-risk-indicator__indicator--off`
        return ClassName
    }

    buildRiskIndicator(){
        const { risk, maxRisk } = this.props;
        let riskArray=[];
        for (let i = 0; i < maxRisk; i++) {
            i < risk
            ? riskArray.push(this.indicatorClassName(true, i+1))
            : riskArray.push(this.indicatorClassName(false, i+1))
        }
        return riskArray.map((indicator, index) => {
            return <div className={indicator} key={index} />
        })
    }

    render(){
        const { risk, maxRisk } = this.props;
        const riskResult = `${risk}${SLASH}${maxRisk}`;
        const riskIndicator = this.buildRiskIndicator();
        const riskLabel = formatText('brokerAdvancedSearch-brokerAdvancedSearch_risk');
        return(
            <div className="broker-advanced-search-result-risk-indicator">
                <div className="broker-advanced-search-result-risk-indicator__label">{riskLabel}</div>
                <div className="broker-advanced-search-result-risk-indicator__risk">{riskResult}</div>
                <div className="broker-advanced-search-result-risk-indicator__indicator">
                    {riskIndicator}
                </div>
            </div>
        )
    }
}

BrokerAdvancedSearchResultRiskIndicator.propTypes = {
    risk: PropTypes.string,
    maxRisk: PropTypes.string
}

module.exports = BrokerAdvancedSearchResultRiskIndicator;